export function useArtworkFilters() {
  const getFilters = (data) => {
    const { artworkTypes, decades, movements, sites, specialCollections } = data;

    return { artworkTypes, decades, movements, sites, specialCollections };
  };

  return { getFilters };
}
